"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const CloseButton_1 = __importDefault(require("~/components/common/controls/CloseButton"));
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const AddressEditModal_1 = __importDefault(require("../AddressEditModal"));
const ChangeCredentials_1 = require("../ChangeCredentials/ChangeCredentials");
const AddressEditWindow_module_scss_1 = __importDefault(require("./AddressEditWindow.module.scss"));
function AddressEditWindow({ cancelHandler, submitHandler, customer, distributorId }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { t } = (0, react_i18next_1.useTranslation)('quote-widget');
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const [submitted, setSubmitted] = (0, react_1.useState)();
    const [disabled, setDisabled] = (0, react_1.useState)(true);
    const { dispatchUpdateAddressDataAction, dispatchCreateAddressDataAction } = (0, redux_1.bindActionCreators)({
        dispatchUpdateAddressDataAction: actions_1.updateAddressDataAction,
        dispatchCreateAddressDataAction: actions_1.createAddressDataAction,
    }, (0, react_redux_1.useDispatch)());
    return (react_1.default.createElement("div", { className: AddressEditWindow_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: AddressEditWindow_module_scss_1.default.headline },
            react_1.default.createElement("div", { className: AddressEditWindow_module_scss_1.default.title },
                react_1.default.createElement("span", null, t('title.add-new-address')),
                ' ',
                (0, ChangeCredentials_1.profileButtons)(cancelHandler, () => setSubmitted(true), disabled, t)),
            react_1.default.createElement(CloseButton_1.default, { onCLickHandler: cancelHandler })),
        react_1.default.createElement("div", { className: AddressEditWindow_module_scss_1.default.userData },
            react_1.default.createElement("div", { className: AddressEditWindow_module_scss_1.default.info },
                react_1.default.createElement("span", null, t('title.first-name')),
                react_1.default.createElement("div", null, (_a = customer === null || customer === void 0 ? void 0 : customer.firstName) !== null && _a !== void 0 ? _a : user === null || user === void 0 ? void 0 : user.firstName)),
            react_1.default.createElement("div", { className: AddressEditWindow_module_scss_1.default.info },
                react_1.default.createElement("span", null, t('title.last-name')),
                react_1.default.createElement("div", null, (_b = customer === null || customer === void 0 ? void 0 : customer.lastName) !== null && _b !== void 0 ? _b : user === null || user === void 0 ? void 0 : user.lastName)),
            react_1.default.createElement("div", { className: AddressEditWindow_module_scss_1.default.info },
                react_1.default.createElement("span", null, t('title.company-name')),
                react_1.default.createElement("div", null, (_f = (_d = (_c = customer === null || customer === void 0 ? void 0 : customer.company) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : (_e = user === null || user === void 0 ? void 0 : user.company) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : '-')),
            react_1.default.createElement("div", { className: AddressEditWindow_module_scss_1.default.info },
                react_1.default.createElement("span", null, t('title.phone-number')),
                react_1.default.createElement("div", null, (_h = (_g = customer === null || customer === void 0 ? void 0 : customer.phoneNumber) !== null && _g !== void 0 ? _g : user === null || user === void 0 ? void 0 : user.phoneNumber) !== null && _h !== void 0 ? _h : '-'))),
        react_1.default.createElement(AddressEditModal_1.default, { headlineHidden: true, onClose: cancelHandler, onSubmit: (newAddress) => {
                if (newAddress === null || newAddress === void 0 ? void 0 : newAddress.id) {
                    dispatchUpdateAddressDataAction(newAddress);
                }
                else {
                    dispatchCreateAddressDataAction(Object.assign(Object.assign({}, newAddress), { userId: customer === null || customer === void 0 ? void 0 : customer.id }));
                }
                submitHandler();
            }, isSubmitted: submitted, setDisabled: (status) => setDisabled(status), distributorId: distributorId })));
}
AddressEditWindow.defaultProps = {
    customer: undefined,
    distributorId: undefined,
};
exports.default = AddressEditWindow;
